'use client';

import { c as _c } from "react/compiler-runtime";
import type { FundingSavedCard } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';
import { AnimatedButton } from '@/components/ui/animated-button';
import { ArrowRight01Icon } from '@/components/ui/icon/glyphs';
export function FundingSavedCardRow(t0) {
  const $ = _c(32);
  const {
    card,
    busy,
    onSelect,
    onRemove
  } = t0;
  const t = useTranslations("onramp");
  const t1 = busy || !card.availability.active;
  let t2;
  if ($[0] !== card.id || $[1] !== onSelect) {
    t2 = () => onSelect(card.id);
    $[0] = card.id;
    $[1] = onSelect;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <OptimizedImage nsfw={false} variant="thumbnail" preview={false} loadReveal="none" rounded="" imageClassName="object-contain" src="/assets/onramp/method-card.png" alt="" size="size-10" className="bg-transparent" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== card.brand || $[5] !== card.last4 || $[6] !== t) {
    t4 = t("saved_card_label", {
      brand: card.brand,
      last4: card.last4
    });
    $[4] = card.brand;
    $[5] = card.last4;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="text-body font-medium">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== card.availability.active || $[11] !== t) {
    t6 = card.availability.active ? t("previously_used") : t("card_unavailable");
    $[10] = card.availability.active;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <span className="text-caption text-foreground-secondary">{t6}</span>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <span className="flex items-center gap-3">{t3}<span className="flex flex-col items-start">{t5}{t7}</span></span>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t8) {
    t9 = <AnimatedButton variant="tertiary" suffix={ArrowRight01Icon} className="h-auto min-h-16.5 flex-1 justify-between rounded-control p-3" disabled={t1} onClick={t2}>{t8}</AnimatedButton>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== busy || $[23] !== card.allowsDeletion || $[24] !== card.id || $[25] !== card.last4 || $[26] !== onRemove || $[27] !== t) {
    t10 = card.allowsDeletion ? <AnimatedButton variant="tertiary" disabled={busy} aria-label={t("remove_card_label", {
      last4: card.last4
    })} onClick={() => onRemove(card.id)}>{t("remove_card")}</AnimatedButton> : null;
    $[22] = busy;
    $[23] = card.allowsDeletion;
    $[24] = card.id;
    $[25] = card.last4;
    $[26] = onRemove;
    $[27] = t;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t9) {
    t11 = <div className="flex items-center gap-2">{t9}{t10}</div>;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}